module.exports = __webpack_public_path__ + "02_long_brown.30b761d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_long_brown.png
// module id = xtQp
// module chunks = 0